import { render, staticRenderFns } from "./AtopicDermatitisQuestion.vue?vue&type=template&id=62659b29&"
import script from "./AtopicDermatitisQuestion.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports